export const ariaTabId = (tab: number) => `store-locator-tab-${tab}`;

export const ariaTabPanel = (tab: number) => `store-locator-tabpanel-${tab}`;

export function a11yPropsTabs(tab: number) {
  return { id: ariaTabId(tab), ariaControls: ariaTabPanel(tab) };
}

export function a11yPropsPanels(tab: number) {
  return { id: ariaTabPanel(tab), ariaLabeledBy: ariaTabId(tab) };
}
